import { render, staticRenderFns } from "./SelectedMemberNotification.vue?vue&type=template&id=4d9046e0&"
import script from "./SelectedMemberNotification.vue?vue&type=script&lang=js&"
export * from "./SelectedMemberNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports